/* pers-megamenu.js — pozycja pozioma nowych paneli menu (zadanie 38).

   Panel jest potomkiem pozycji menu (tego wymaga mechanika motywu: mouseenter/
   mouseleave na pozycji i parowanie `.has-children` ↔ `.child` po indeksie). Szeroki
   panel liczony od lewej krawędzi pozycji wychodziłby za ekran przy drugiej pozycji,
   więc przesuwamy go zmienną --pmm-x: środek panelu pod środkiem całego menu,
   z marginesem 16 px od krawędzi ekranu. Sama widoczność zostaje motywu.

   Bez tego skryptu panel stoi od lewej krawędzi pozycji — działa, tylko mniej ładnie.
*/
(function () {
  'use strict';
  var menu = document.querySelector('.header .header__menu');
  if (!menu) return;
  var panele = menu.querySelectorAll('.child.pmm');
  if (!panele.length) return;

  function ustaw(panel) {
    var li = panel.parentElement;
    if (!li) return;
    var m = menu.getBoundingClientRect(), l = li.getBoundingClientRect();
    var szer = panel.offsetWidth;
    if (!szer) return;
    var cel = m.left + m.width / 2 - szer / 2;                         // środek pod menu
    cel = Math.max(16, Math.min(cel, window.innerWidth - 16 - szer));  // w ekranie
    panel.style.setProperty('--pmm-x', Math.round(cel - l.left) + 'px');
  }
  function wszystkie() { for (var i = 0; i < panele.length; i++) ustaw(panele[i]); }

  for (var i = 0; i < panele.length; i++) {
    (function (panel) {
      var li = panel.parentElement;
      li.addEventListener('mouseenter', function () { ustaw(panel); });
      li.addEventListener('focusin', function () { ustaw(panel); });
    })(panele[i]);
  }
  window.addEventListener('resize', wszystkie, { passive: true });
  wszystkie();
})();
